module.exports = __webpack_public_path__ + "LatoLatin-Italic.5e75c678391d787696bb.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-Italic.woff2
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-Italic.woff2
// module chunks = styles